import api, { publicAxiosInstance }  from "../utils/API";

const getAll = ({ page, limit, search, years, contrats }) => {
  const params = new URLSearchParams();

  params.append('page', page);
  params.append('limit', limit);

  if (search) params.append('search', search);
  if (years && years.length > 0) {
    params.append('year', years.join(','));
  }
  if (contrats?.length) params.append('contrats', contrats.join(','));


  return api.get(`/Collaborateurs/list?${params.toString()}`);
};

const getYears = () => {
  return api.get('/Collaborateurs/years');
};


const getCollaborateurById = (id) => {
  return api.get(`/Collaborateurs/${id}`);
};

const updateCollaborateur = (id, data) => {
  return api.put(`/Collaborateurs/${id}`, data);
};

const renewCollaborateurManually = (
  id,
  { periodeContrat, dateDebut, dateFinContrat, contratId }
) => {
  return api.post(`/Collaborateurs/${id}/renouvellement-manuel`, {
    periodeContrat,
    dateDebut,
    dateFinContrat,
    contratId,
  });
};

const addCollaborateurDocument = (idCollaborateur, file, type) => {
  const formData = new FormData();
  formData.append('idCollaborateur', idCollaborateur);
  formData.append('file', file);
  formData.append('type', type);

  return api.post('/Collaborateurs/documents/add', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

const getCollaborateurDocuments = (collaborateurId, category = null) => {
  let url = `/Collaborateur/${collaborateurId}/documents`;
  if (category) {
    url += `?category=${encodeURIComponent(category)}`;
  }
  return api.get(url);
};

const deleteCollaborateurDocument = (documentId) => api.delete(`/Collaborateurs/documents/${documentId}`);

const getPublicCollaborateurById = (id, code) => {
  return publicAxiosInstance.get(`/collaborateur/public/${id}`, {
    params: { code }
  });
};

export {
  getAll,
  getYears,
  getCollaborateurById,
  updateCollaborateur,
  renewCollaborateurManually,
  addCollaborateurDocument,
  getCollaborateurDocuments,
  deleteCollaborateurDocument,
  getPublicCollaborateurById
};

